import { useEffect, useState, useContext } from 'react';
import { HotelContext } from '../context/hotel';
import Session from 'react-session-api';

export const useLanguage = () => {
    const _languageMap = {
        "ES": "es-ES",
        "US": "en-US",
        "DE": "de",
        "IT": "it",
        "FR": "fr"
    };
    
    const { code, languages } = useContext(HotelContext);
    let _defaultLang = languages[0] || 'en-US';
    _defaultLang = _defaultLang.toLowerCase();
    if (_defaultLang == 'us') {
        _defaultLang = 'en-US';
    }
    if (_defaultLang == 'es') {
        _defaultLang = 'es-ES';
    }
    const [ language, setLanguageState ] = useState(null)

    const setLanguage = (language) => {
        // Persistencia


        window.localStorage.setItem(`rtc-lang-${code}`, language);

        // Parche para que el complemento de traducción aplique sin refrescar página
        const _sessionLang = Session.get('language');
        if (_sessionLang !== language) {
            Session.set('language', language)
        }

        // Actualizo el estado
        setLanguageState(language)
    }

    const setLanguageByCode = (code) => {
        let l = _languageMap[code];
        if (l) {
            setLanguage(l);            
        } else {
            setLanguage(_defaultLang);
        }
    }

    const languageCode = (lang) => {
        const entry = Object.entries(_languageMap).find(([key, val]) => val === lang);
        return entry ? entry[0] : null;
    }

    // const shortLanguage = useMemo(() => {
    //     if (!language) return null;
    //     return language.substring(0, 2);
    // }, [ language ])

    const defaultLanguage = () => {
        return _defaultLang;
    }

    useEffect(() => {
        const persistedLang = window.localStorage.getItem(`rtc-lang-${code}`);
        if (!language) {
            if (persistedLang) {
                setLanguage(persistedLang)
            } else {
                setLanguage(_defaultLang)
            }
        }
    }, [language])

    return {
        language,

        languageCode,

        setLanguage,
        // shortLanguage

        setLanguageByCode,

        defaultLanguage
    }
}